import ListItem from './list-item/ContractSideMenuTemplateListItem';
import Templates from './templates';
import Wrapper from './wrapper/ContractSideMenuTemplateListWrapper';

export default { Wrapper, ListItem, Templates };
